var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85838 7.64563C7.46038 7.64563 7.95038 8.13213 7.95038 8.73013V10.2681C7.95038 10.3966 8.05338 10.4996 8.18538 10.5026H9.13838C9.88938 10.5026 10.4999 9.89963 10.4999 9.15863V4.79663C10.4964 4.54163 10.3749 4.30163 10.1664 4.14213L6.86988 1.51313C6.42738 1.16263 5.80838 1.16263 5.36438 1.51413L2.09038 4.14113C1.87388 4.30563 1.75238 4.54563 1.74988 4.80513V9.15863C1.74988 9.89963 2.36038 10.5026 3.11138 10.5026H4.07338C4.20888 10.5026 4.31888 10.3951 4.31888 10.2631C4.31888 10.2341 4.32238 10.2051 4.32838 10.1776V8.73013C4.32838 8.13563 4.81538 7.64963 5.41288 7.64563H6.85838ZM9.13838 11.2526H8.17638C7.62538 11.2396 7.20038 10.8071 7.20038 10.2681V8.73013C7.20038 8.54563 7.04688 8.39563 6.85838 8.39563H5.41538C5.23088 8.39663 5.07838 8.54713 5.07838 8.73013V10.2631C5.07838 10.3006 5.07338 10.3366 5.06288 10.3706C5.00888 10.8656 4.58588 11.2526 4.07338 11.2526H3.11138C1.94688 11.2526 0.999878 10.3131 0.999878 9.15863V4.80163C1.00488 4.30463 1.23388 3.84963 1.62938 3.55013L4.89688 0.927625C5.61638 0.357625 6.61888 0.357625 7.33688 0.926625L10.6279 3.55163C11.0144 3.84613 11.2434 4.30013 11.2499 4.79113V9.15863C11.2499 10.3131 10.3029 11.2526 9.13838 11.2526Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4a12eea5860e030f2a9cadbd65834269.svg";
export { ForwardRef as ReactComponent };